import React from 'react';
import { renderEmailToHtml } from '../../emails/renderEmail';

interface EmailPreviewProps {
  EmailComponent: React.ComponentType<any>;
  props: Record<string, any>;
  className?: string;
}

/**
 * Componente para previsualização de templates de email
 */
const EmailPreview: React.FC<EmailPreviewProps> = ({
  EmailComponent,
  props,
  className = '',
}) => {
  // Renderiza o componente para HTML
  const htmlContent = renderEmailToHtml(EmailComponent, props);

  return (
    <div className={`email-preview-container ${className}`}>
      <iframe
        srcDoc={htmlContent}
        title="Email Preview"
        className="w-full h-[600px] border-0 mt-2"
        sandbox="allow-same-origin allow-scripts"
      />
    </div>
  );
};

export default EmailPreview; 